import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InteractionPageRoutingModule } from './interaction-page-routing.module';
import { GamesComponent } from 'src/app/components/games/games.component';
import { InteractionPageComponent } from './interaction-page.component';
import { PuzzleComponent } from 'src/app/components/games/puzzle/puzzle.component';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { TrovaErroreComponent } from 'src/app/components/games/trova-errore/trova-errore.component';
import { OrientationAlertComponent } from 'src/app/components/orientation-alert/orientation-alert.component';
import { VideoComponent } from 'src/app/components/video/video.component';
import { AudioComponent } from 'src/app/components/audio/audio.component';
import { ImageComponent } from 'src/app/components/image/image.component';
import { EmbedVideo } from 'ngx-embed-video';
import { SharedModule } from 'src/app/components/shared.module';
import { MemoryComponent } from 'src/app/components/games/memory/memory.component';
import { ScratchComponent } from 'src/app/components/games/scratch/scratch.component';
import { CrucintarsioComponent } from 'src/app/components/games/crucintarsio/crucintarsio.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { QuadratoMagicoComponent } from 'src/app/components/games/quadrato-magico/quadrato-magico.component';
import { QuadratomagicoComponent } from 'src/app/components/games/quadratomagico/quadratomagico.component';
import { QuizComponent } from 'src/app/components/games/quiz/quiz.component';
import { MappaComponent } from 'src/app/components/games/mappa/mappa.component';
import { NewScratchComponent } from 'src/app/components/games/new-scratch/new-scratch.component';


@NgModule({
  declarations: [
    InteractionPageComponent,
    GamesComponent,
    PuzzleComponent,
    TrovaErroreComponent,
    MemoryComponent,
    ScratchComponent,
    NewScratchComponent,
    CrucintarsioComponent,
    QuadratoMagicoComponent,
    QuadratomagicoComponent,
    QuizComponent,
    MappaComponent
  ],
  imports: [
    CommonModule,
    InteractionPageRoutingModule,
    DragAndDropModule,
    EmbedVideo,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class InteractionPageModule { }
